<template>
  <v-text-field
    v-bind="$props"
    v-on="$listeners"
    :prepend-inner-icon="mdiLock"
    :append-icon="mode ? mdiEye : mdiEyeOff"
    @click:append="() => (mode = !mode)"
    :data-cy="dataCy"
    :autocomplete="autocomplete"
    :type="mode ? 'password' : 'text'" />
</template>

<script>
import { mdiEye, mdiEyeOff, mdiLock } from '@mdi/js';
import { VTextField } from 'vuetify/lib';

export default {
  extends: VTextField,
  name: 'PasswordField',
  props: {
    dataCy: {
      type: String,
      default: 'password-field',
    },
    /**
     * Holds the autocomplete value, with a default of 'password'
     */
    autocomplete: {
      type: String,
      default: 'password',
    },
  },
  data() {
    return {
      /** Icons
       */
      mdiEye,
      mdiEyeOff,
      mdiLock,
      /** Mode used to control the visibility of the password
      */
      mode: String,
    };
  },
};
</script>
